import styled from 'styled-components';

export const EmailView = styled.iframe`
  width: 100%;
  height: 450px;
`;
